//
//
//
//
//
//
//
//
//
//
//
//

import HeadPicFile from './HeadPicFile/HeadPicFile.vue';
export default {
    components: {
        HeadPicFile
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        }
    },
    data() {
        return {

        }
    },
    methods: {
        submit(e) {
            console.log(this.img);
        },
        handleFileChange() {

        },
        setImg(e) {
            let inputDOM = this.$refs.inputFile;
            // 通过DOM取文件数据
            this.file = inputDOM.files[0];
            this.errText = '';
            let size = Math.floor(this.file.size / 1024);

            console.log(size);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/Header.vue